module.exports = __webpack_public_path__ + "img/dollar-rounded.82242db6.svg";